export class AdditionalField {
  id: string = '';
  label?: string;
  type?: string;
  required?: boolean;
  lengthLimit?: number;
  selectableValues: string[] = [];
  selectShowOther?: boolean;
  multiSelect?: boolean;
  minValue: number = -Infinity;
  maxValue: number = Infinity;
  checkboxLabel?: string;


  public static createFromJson(input: any): AdditionalField {
    const data = new AdditionalField();
    data.fromJson(input);
    return data;
  }

  fromJson(input: any) {
    this.id = input['id'];
    this.label = input['label'];
    this.type = input['type'];
    this.required = input['required'];
    this.lengthLimit = input['lengthLimit'];
    if (input['selectableValues']) {
      for (const child of input['selectableValues']) {
        this.selectableValues.push(child);
      }
    }
    this.selectShowOther = input['selectShowOther'];
    this.multiSelect = input['multiSelect'];
    this.minValue = input['minValue'];
    this.maxValue = input['maxValue'];
    this.checkboxLabel = input['checkboxLabel'];
  }

  toJson(): any {
    return {
      id: this.id,
      label: this.label,
      type: this.type,
      required: this.required,
      lengthLimit: this.lengthLimit,
      selectableValues: [...this.selectableValues],
      selectShowOther: this.selectShowOther,
      multiSelect: this.multiSelect,
      minValue: this.minValue,
      maxValue: this.maxValue,
      checkboxLabel: this.checkboxLabel
    };
  }
}
